import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { FiArrowLeft, FiCalendar, FiUser } from 'react-icons/fi';
import '../styles/BlogDetail.css';

const BlogDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Check if blog data was passed via location state (for static blogs)
        if (location.state?.blog) {
            setBlog(location.state.blog);
            setLoading(false);
        } else {
            // Fetch from Firebase
            fetchBlog();
        }
    }, [id, location]);

    const fetchBlog = async () => {
        try {
            const blogDoc = await getDoc(doc(db, 'blogs', id));
            if (blogDoc.exists()) {
                setBlog({ id: blogDoc.id, ...blogDoc.data() });
            } else {
                navigate('/blogs');
            }
        } catch (error) {
            console.error('Error fetching blog:', error);
            navigate('/blogs');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return '';
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="blog-detail-loading">
                <div className="spinner"></div>
                <p>Loading blog...</p>
            </div>
        );
    }

    if (!blog) {
        return null;
    }

    return (
        <div className="blog-detail">
            <div className="blog-detail-header">
                <div className="container">
                    <button
                        className="btn-back-blog"
                        onClick={() => navigate('/blogs')}
                    >
                        <FiArrowLeft /> Back to Blogs
                    </button>
                </div>
            </div>

            <article className="blog-detail-content">
                <div className="container">
                    {(blog.imageUrl || blog.image) && (
                        <div className="blog-detail-image">
                            <img src={blog.imageUrl || blog.image} alt={blog.title} />
                        </div>
                    )}

                    <div className="blog-detail-body">
                        {blog.category && (
                            <span className="blog-category">{blog.category}</span>
                        )}

                        <h1 className="blog-title">{blog.title}</h1>

                        <div className="blog-meta-info">
                            {blog.createdAt && (
                                <span className="meta-item">
                                    <FiCalendar /> {formatDate(blog.createdAt)}
                                </span>
                            )}
                            {blog.author && (
                                <span className="meta-item">
                                    <FiUser /> {blog.author}
                                </span>
                            )}
                        </div>

                        {blog.excerpt && (
                            <p className="blog-excerpt-detail">{blog.excerpt}</p>
                        )}

                        <div className="blog-content">
                            {blog.content.split('\n').map((paragraph, index) => (
                                paragraph.trim() && <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default BlogDetail;
